import React from "react";
import { Box, Typography, Slider } from "@mui/material";

const PopularitySelectSection = ({ formData, setFormData }) => {
  return (
    <Box sx={{ my: 2 }}>
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Popularity
      </Typography>

      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Typography variant="caption" sx={{ whiteSpace: "nowrap" }}>
          Most Popular (0)
        </Typography>
        <Typography variant="caption" sx={{ whiteSpace: "nowrap" }}>
          Least Popular (10)
        </Typography>
      </Box>

      <Slider
        value={formData.popularity ?? 0}
        onChange={(e, newValue) =>
          setFormData((prev) => ({ ...prev, popularity: newValue }))
        }
        step={1}
        min={0}
        max={10}
        valueLabelDisplay="auto"
      />
    </Box>
  );
};

export default PopularitySelectSection;
